// src/pages/AboutPage.js
import React from "react";
import TigerLogo from "../components/common/TigerLogo";

export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-16">
      <div className="text-center mb-12 animate-fade-in-up">
        <div className="flex justify-center mb-6">
          <div className="relative">
            <TigerLogo size={100} />
            <div className="absolute inset-0 bg-tiger-500/10 rounded-full blur-2xl scale-150" />
          </div>
        </div>
        <h1 className="font-display text-4xl font-bold tracking-wider">
          <span className="text-tiger-400">EVANDER</span>{" "}
          <span className="text-onyx-100">CAMPUS</span>
        </h1>
        <p className="font-display text-sm text-onyx-500 tracking-widest mt-2">
          PSAL ATHLETICS · BRONX, NEW YORK
        </p>
      </div>

      <div className="space-y-8 animate-fade-in-up stagger-2">
        <div className="rounded-xl bg-onyx-900/50 border border-onyx-800/30 p-8">
          <h2 className="font-display text-lg font-semibold text-tiger-400 tracking-wider mb-4">OUR MISSION</h2>
          <p className="font-body text-onyx-300 leading-relaxed">
            The Evander Childs Campus Athletic Program provides student-athletes across the Bronx
            with opportunities to compete, grow, and excel through PSAL athletics. We believe sports
            build character, discipline, and community — values that carry well beyond the playing field.
          </p>
        </div>

        <div className="rounded-xl bg-onyx-900/50 border border-onyx-800/30 p-8">
          <h2 className="font-display text-lg font-semibold text-tiger-400 tracking-wider mb-4">HOME OF THE TIGERS</h2>
          <p className="font-body text-onyx-300 leading-relaxed">
            Our Tigers compete in multiple PSAL sports including Basketball, Baseball, Football, Soccer,
            Track & Field, Swimming, and Volleyball. With dedicated coaching staff and passionate
            student-athletes, we carry the Tiger pride in every game, match, and meet.
          </p>
        </div>

        <div className="rounded-xl bg-onyx-900/50 border border-onyx-800/30 p-8">
          <h2 className="font-display text-lg font-semibold text-tiger-400 tracking-wider mb-4">THE PSAL</h2>
          <p className="font-body text-onyx-300 leading-relaxed">
            The Public Schools Athletic League (PSAL) is the athletic league for New York City public
            high schools. As one of the largest school-based athletic programs in the country, PSAL
            gives thousands of students the chance to compete at the interscholastic level while
            maintaining academic standards.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { label: "Sports", value: "7+" },
            { label: "Student Athletes", value: "200+" },
            { label: "Coaching Staff", value: "15+" },
            { label: "Borough", value: "Bronx" },
          ].map((stat) => (
            <div key={stat.label} className="rounded-xl bg-onyx-900/40 border border-onyx-800/20 p-5 text-center">
              <p className="font-display text-2xl font-bold text-tiger-400">{stat.value}</p>
              <p className="text-xs font-display text-onyx-500 tracking-wider mt-1 uppercase">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
